export const CALLBOX_BADGE_COLORS = {
  warning: 'd-recipe-callbox-badge--warning',
};

export const CALLBOX_BORDER_COLORS = {
  default: 'd-recipe-callbox__border-default',
  ai: 'd-recipe-callbox__border-ai',
  critical: 'd-recipe-callbox__border-critical',
};

export default {
  CALLBOX_BADGE_COLORS,
  CALLBOX_BORDER_COLORS,
};
